import React from 'react';

const AiIcon = ({ className, size = 20 }) => (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
        <path d="M11 3l1.6 4.4L17 9l-4.4 1.6L11 15l-1.6-4.4L5 9l4.4-1.6z" fill="currentColor" />
        <path d="M18.5 13l.55 1.85 1.85.55-1.85.55-.55 1.85-.55-1.85-1.85-.55 1.85-.55z" fill="currentColor" />
    </svg>
);

export default AiIcon;



// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/AiIcon.jsx